import { put, select, takeLatest } from 'redux-saga/effects'
import { getVentilatorSelector } from '../selectors'
import { setAirTemperatureUnitTemp, saveVentilator } from '../store/ventilator.actions'
import { VentilatorConstants } from '../store/ventilator.constants'
import { IVentilatorState } from '../store/ventilator.types'

export function* setVentilatorTemperatureUnit() {
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const { airTemperatureBool, airTemperatureUnit } = ventilatorState
  let data = null
  if (airTemperatureBool) {
    data = { id: 'f', name: 'F' }
  } else {
    data = { id: 'c', name: 'C' }
  }
  yield put(setAirTemperatureUnitTemp(data))
  if (airTemperatureUnit) yield put(saveVentilator())
}

export function* setVentilatorTemperatureUnitSaga() {
  yield takeLatest([VentilatorConstants.SET_AIR_TEMPERATURE_UNIT], setVentilatorTemperatureUnit)
}
